import { Prompt, Redirect } from "react-router-dom";
import { useIsReadOnlyMode } from "components/AnalysisRenderMode";

export default function SavePrompt({ blockIf, redirectIf, redirectTo }) {
    const isReadOnlyMode = useIsReadOnlyMode();
    if (isReadOnlyMode)
        return null;

    if (redirectIf) return <Redirect to={redirectTo} />;

    return <Prompt when={blockIf} message="Are you sure you want to leave without saving?" />;
}
